class User {
  constructor({ user_id, user_type }) {
    this.user_id = user_id;
    this.user_type = user_type;
  }
}

export default User;
